module.exports = {
    nullTips: 'User name and password can not be null.',
    loginWrong: 'Incorrect user name or password.',
    userName: 'User Name',
    password: 'Password',
    login: 'Login'
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/i18n/locale.en.js
// module id = 4
// module chunks = 0